import { Facebook, X } from 'lucide-react';

// Facebook group URL
export const FACEBOOK_GROUP_URL = 'https://www.facebook.com/groups/1483887879720908';

/**
 * Facebook Community Banner
 * Shown to encourage users to join the Facebook group
 */
const FacebookBanner = ({ show, onDismiss }) => {
  if (!show) return null;
  
  return (
    <div className="absolute top-0 left-0 right-0 z-[1100] bg-gradient-to-r from-blue-600 to-blue-700 text-white py-2 px-4 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Facebook className="w-5 h-5" />
          <span className="text-sm font-medium">
            Join our Facebook community! Share finds, get tips, and connect with neighbours.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <a
            href={FACEBOOK_GROUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-4 py-1 rounded-full text-sm font-semibold hover:bg-blue-50 transition-colors"
            data-testid="fb-join-btn"
          >
            Join Now
          </a>
          <button
            onClick={onDismiss}
            className="text-white/80 hover:text-white p-1"
            aria-label="Dismiss"
            data-testid="fb-dismiss-btn"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FacebookBanner;
